import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import { HomePage } from "./pages/Home";
import { MembershipPage } from "./pages/Membership";
import { BranchesListPage } from "./pages/BranchesList";
import { BranchDetailPage } from "./pages/BranchDetail";
import { BatchesListPage } from "./pages/BatchesList";
import { BatchDetailPage } from "./pages/BatchDetail";
import { AssociationsListPage } from "./pages/AssociationsList";
import { AssociationDetailPage } from "./pages/AssociationDetail";
import { NewsListPage } from "./pages/NewsList";
import { OtherNewsListPage } from "./pages/OtherNewsList";
import { NewsDetailPage } from "./pages/NewsDetail";
import { ContactPage } from "./pages/Contact";
import { AboutObaPage } from "./pages/AboutOba";
import { AboutPillarsPage } from "./pages/AboutPillars";
import { ProjectsListPage } from "./pages/ProjectsList";
import { OtherProjectsListPage } from "./pages/OtherProjectsList";
import { ProjectDetailPage } from "./pages/ProjectDetail";
import { AdminLoginPage } from "./pages/admin/AdminLogin";
import { AdminProtected } from "./pages/admin/AdminProtected";
import { AdminDashboard } from "./pages/admin/AdminDashboard";
import { TasksLoginPage } from "./pages/tasks/TasksLogin.tsx";
import { TasksProtected } from "./pages/tasks/TasksProtected.tsx";
import { TasksPage } from "./pages/tasks/TasksPage.tsx";
import { TasksNewPage } from "./pages/tasks/TasksNewPage.tsx";
import { TasksTaskPage } from "./pages/tasks/TasksTaskPage.tsx";
import { MeetingAgendaPage } from "./pages/tasks/MeetingAgendaPage.tsx";
import { TasksDashboardPage } from "./pages/tasks/TasksDashboardPage.tsx";
import { ExcoDashboardPage } from "./pages/exco/ExcoDashboardPage.tsx";

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="alumni" element={<Navigate to="/" replace />} />
        <Route path="alumni/membership" element={<MembershipPage />} />
        <Route path="alumni/branches" element={<BranchesListPage />} />
        <Route path="alumni/branches/:slug" element={<BranchDetailPage />} />
        <Route path="alumni/batches" element={<BatchesListPage />} />
        <Route path="alumni/batches/:slug" element={<BatchDetailPage />} />
        <Route path="alumni/associations" element={<AssociationsListPage />} />
        <Route path="alumni/associations/:slug" element={<AssociationDetailPage />} />
        <Route path="about" element={<AboutObaPage />} />
        <Route path="about/pillars" element={<Navigate to="/pillars" replace />} />
        <Route path="pillars" element={<AboutPillarsPage />} />
        <Route path="projects/other" element={<OtherProjectsListPage />} />
        <Route path="projects/:projectId" element={<ProjectDetailPage />} />
        <Route path="projects" element={<ProjectsListPage />} />
        <Route path="news" element={<NewsListPage />} />
        <Route path="news/:slug" element={<NewsDetailPage />} />
        <Route path="news/other" element={<OtherNewsListPage />} />
        <Route path="news/other/:slug" element={<NewsDetailPage />} />
        <Route path="contact" element={<ContactPage />} />
      </Route>
      <Route path="admin/login" element={<AdminLoginPage />} />
      <Route
        path="admin"
        element={
          <AdminProtected>
            <AdminDashboard />
          </AdminProtected>
        }
      />
      <Route path="tasks/login" element={<TasksLoginPage />} />
      <Route
        path="exco"
        element={
          <TasksProtected>
            <ExcoDashboardPage />
          </TasksProtected>
        }
      />
      <Route
        path="agenda"
        element={
          <TasksProtected>
            <MeetingAgendaPage />
          </TasksProtected>
        }
      />
      <Route
        path="tasks"
        element={
          <TasksProtected>
            <TasksPage />
          </TasksProtected>
        }
      />
      <Route
        path="tasks/dashboard"
        element={
          <TasksProtected>
            <TasksDashboardPage />
          </TasksProtected>
        }
      />
      <Route
        path="tasks/new"
        element={
          <TasksProtected>
            <TasksNewPage />
          </TasksProtected>
        }
      />
      <Route
        path="tasks/meeting-agenda"
        element={<Navigate to="/agenda" replace />}
      />
      <Route
        path="tasks/:taskId"
        element={
          <TasksProtected>
            <TasksTaskPage />
          </TasksProtected>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
